module.exports = __webpack_public_path__ + "static/05-307946de7cbf626d52f7b3bb86425e60.jpeg";